import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { i18n } from "services/i18nService";

import { useCategories } from "hooks/useCategories";

export function FrmCategory(props) {
  const {
    value,
    onValueChange,
    width,
    disabled,
    placeholder,
    dataTesting = "category",
  } = props;

  const categories = useCategories();

  return (
    <FrmSelectFromObjects
      name="category"
      options={categories}
      value={value}
      label={i18n("frmLabel.Category")}
      onValueChange={onValueChange}
      sx={{ width, maxWidth: "100%" }}
      disabled={disabled}
      placeholder={placeholder}
      dataTesting={dataTesting}
    />
  );
}
